import TableAdvancedExample from "./examples/Table.Advanced.Example";
import TableBasicExample from "./examples/Table.Basic.Example";
import TableCheckboxExample from "./examples/Table.Checkbox.Example";
import TableSortableExample from "./examples/Table.Sortable.Example";
import TableWithLinksExample from "./examples/Table.WithLinks.Example";
import TableShimmerExample from "./examples/Table.Shimmer.Example";
import TableWithAsyncExample from "./examples/Table.WithAsync.Example";
import TableWithBreakpointsExample from "./examples/Table.WithBreakpoints.Example";

export default [
    {
        title: "Basic table",
        component: TableBasicExample,
        code: require("!raw-loader!./examples/Table.Basic.Example.tsx"),
        dependencies: {
            "TableData.tsx": require("!raw-loader!./examples/TableData.tsx"),
            "Table.Example.css": require("!raw-loader!./examples/Table.Example.css"),
        },
    },
    {
        title: "Table with sorting",
        component: TableSortableExample,
        code: require("!raw-loader!./examples/Table.Sortable.Example.tsx"),
        dependencies: {
            "TableData.tsx": require("!raw-loader!./examples/TableData.tsx"),
            "Table.Example.css": require("!raw-loader!./examples/Table.Example.css"),
        },
    },
    {
        title: "Advanced table",
        component: TableAdvancedExample,
        code: require("!raw-loader!./examples/Table.Advanced.Example.tsx"),
        dependencies: {
            "TableData.tsx": require("!raw-loader!./examples/TableData.tsx"),
            "Table.Example.css": require("!raw-loader!./examples/Table.Example.css"),
        },
    },
    {
        title: "Table with checkboxes",
        component: TableCheckboxExample,
        code: require("!raw-loader!./examples/Table.Checkbox.Example.tsx"),
        dependencies: {
            "TableData.tsx": require("!raw-loader!./examples/TableData.tsx"),
            "Table.Example.css": require("!raw-loader!./examples/Table.Example.css"),
        },
    },
    {
        title: "Table with links",
        component: TableWithLinksExample,
        code: require("!raw-loader!./examples/Table.WithLinks.Example.tsx"),
        dependencies: {
            "TableData.tsx": require("!raw-loader!./examples/TableData.tsx"),
            "Table.Example.css": require("!raw-loader!./examples/Table.Example.css"),
        },
    },
    {
        title: "Table shimmer",
        component: TableShimmerExample,
        code: require("!raw-loader!./examples/Table.Shimmer.Example.tsx"),
        dependencies: {
            "TableData.tsx": require("!raw-loader!./examples/TableData.tsx"),
            "Table.Example.css": require("!raw-loader!./examples/Table.Example.css"),
        },
    },
    {
        title: "Table with async",
        component: TableWithAsyncExample,
        code: require("!raw-loader!./examples/Table.WithAsync.Example.tsx"),
        dependencies: {
            "TableData.tsx": require("!raw-loader!./examples/TableData.tsx"),
            "Table.Example.css": require("!raw-loader!./examples/Table.Example.css"),
        },
    },
    {
        title: "Table with breakpoints",
        component: TableWithBreakpointsExample,
        code: require("!raw-loader!./examples/Table.WithBreakpoints.Example.tsx"),
        dependencies: {
            "TableData.tsx": require("!raw-loader!./examples/TableData.tsx"),
            "Table.Example.css": require("!raw-loader!./examples/Table.Example.css"),
        },
    },
];
